module.exports = __webpack_public_path__ + "img/SES_40_69_003_070.95f2a1f4.jpg";